module.exports = __webpack_public_path__ + "img/right_md_5.361686d6.jpg";